import React from "react";
import styled from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import Icon from "components/common/Icon";
import DocsHelper from "util/DocsHelper";
import useProductName from "brand-customization/useProductName";
import DocumentationLink from "./DocumentationLink";
const SourcesList = styled.ul`
  margin: 0;
  padding: 0;
  margin-top: 5px;
`;
const SupportSources = () => {
  const { t } = useTranslation("common");
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement("div", { className: "support-sources" }, /* @__PURE__ */ React.createElement("h2", null, t("support_sources.title")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "support_sources.help_text",
      values: { productName },
      components: {
        docsLink: /* @__PURE__ */ React.createElement(DocumentationLink, { page: DocsHelper.PAGES.WELCOME, text: t("links.documentation") })
      }
    }
  )), /* @__PURE__ */ React.createElement(SourcesList, null, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(Icon, { name: "group" }), "\xA0", /* @__PURE__ */ React.createElement("a", { href: "https://www.graylog.org/community-support/", target: "_blank", rel: "noopener noreferrer" }, t("support_sources.community_support"))), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(Icon, { name: "bug_report" }), "\xA0\xA0", /* @__PURE__ */ React.createElement("a", { href: "https://github.com/Graylog2/graylog2-server/issues", target: "_blank", rel: "noopener noreferrer" }, t("support_sources.issue_tracker"))), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(Icon, { name: "favorite" }), "\xA0", /* @__PURE__ */ React.createElement("a", { href: "https://www.graylog.org/professional-support", target: "_blank", rel: "noopener noreferrer" }, t("support_sources.professional_support")))));
};
export default SupportSources;
